export const notificationsTypeEnum = {
  ALLOCATION_STATUS_CHANGE: 0,
  ALLOCATION_REQUEST: 1,
  EXTRACT_AVAILABLE: 2,
  DOCUMENTS_SIGNATURE_REQUEST: 3,
  CUSTOM_MSG: 4,
};
